<script>
import Header from './Header.vue';
import ScrollToTop from './ScrollToTop.vue';

export default {
  components: {
    'header-component': Header,
    ScrollToTop
  },
  mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll: function () {
        if (this.scTimer) return;
        this.scTimer = setTimeout(() => {
          this.scY = window.scrollY;
          clearTimeout(this.scTimer);
          this.scTimer = 0;
        }, 100);
      },
      toTop: function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      },
    },
}
</script>

<template>
  <div role="main">
    <div class="top-wrap">
      <div class="top-content">
        <div class="top-banner">
          <header-component></header-component>

          <h1>Process Evaluation</h1>
          <h2><i>Measure and communicate the impact of your process</i></h2>

          <section>
            <p>
              How do you know if your process is working? How do you know if it is even being implemented? Process evaluation helps you assess implementation as well as outcomes.<sup>1</sup>
              Based on those outcomes, you may be able to build a financial case for further investment or innovative agreements with your provider network.
            </p>
          </section>

        </div>
      </div>

      <div class="bottom-banner">
        <p>Process Evaluation Fundamentals</p>
        <p class="bottom-banner-text">
          An evaluation should be systematic and follow a mutually agreed upon plan. For example, if your organization wants to evaluate a new initiative implemented to identify and transition appropriate adult patients with schizophrenia to treatment with long-acting injectable antipsychotics (LAIs), then the general steps to determine might be<sup>1,2</sup>:
        </p>

        <div class="steps">

          <div class="step-item">
            <div class="step-circle">Step 1</div>
            <div class="step-item-desc-wrap">
              <p class="step-title">What is the evaluation question?</p>
              <p class="step-desc">Did outcomes improve for adult patients with schizophrenia who were appropriately switched to treatment with LAIs?</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-circle">Step 2</div>
            <div class="step-item-desc-wrap">
              <p class="step-title">What do you measure?</p>
              <p class="step-desc">Relapses, hospitalizations, healthcare costs, adherence.</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-circle">Step 3</div>
            <div class="step-item-desc-wrap">
              <p class="step-title">How do you measure?</p>
              <p class="step-desc">Collect patient data prior to the switch and after the switch.</p>
            </div>
          </div>
          <div class="step-item">
            <div class="step-circle">Step 4</div>
            <div class="step-item-desc-wrap">
              <p class="step-title">How do you make the results meaningful?</p>
              <p class="step-desc">Present these data to key stakeholders (eg, clinicians, administrators) so they can appreciate the impact and evaluate their own role in the outcomes.</p>
            </div>
          </div>

        </div>

      </div>
    </div>

    <div class="list-content">

      <ScrollToTop />
    </div>

    <div class="body">
      <p class="references">
        <strong>References: 1.</strong> Centers for Disease Control and Prevention. Framework for program evaluation in public health. <i>MMWR Recomm Rep</i>. 1999;48(RR-11):1-40. <br class="remove-br"><strong>2.</strong> Milstein B, Wetterhall S; CDC Evaluation Working Group. A framework featuring steps and standards for program evaluation. <i>Health Promot Pract</i>. 2000;1(3):221-228. doi:10.1177/152483990000100304
      </p>
    </div>
  </div>

</template>

<style scoped>
#app>div {
  width: 100%;
}

/*TOP */

.top-wrap {
  background: rgb(0, 18, 82);
  background: linear-gradient(0deg, rgba(0, 18, 82, 1) 0%, rgba(0, 70, 126, 1) 50%, rgba(0, 70, 126, 1) 100%);
  color: #ffffff;
  width: 100%;
}

.top-content {
  background: linear-gradient(to top, #0079A8, #0084B8);
  border-radius: 0 0 0 100px;
  margin-left: 3%;
  padding-bottom: 50px;
  width: 97%;
}

.top-banner {
  background: url(../img/banner-bg.png) no-repeat 0 0;
  background-size: cover;
  border-radius: 0 0 0 100px;
  margin-left: 1.5%;
  padding-bottom: 60px;
  width: 98.5%;
}

.top-banner section p {
  margin: 1em auto;
}

.top-banner section p{
  line-height: 30px;
}

.top-banner h1 {
  display: block;
  font-family: "Gotham", sans-serif;
  font-weight: bold;
  font-size: 36px;
  line-height: 36px;
  margin: 68px auto 30px auto;
  max-width: 1121px;
  text-align: center;
}

.top-banner h2 {
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 22px;
  font-style: italic;
  font-weight: 400;
  line-height: 24px;
  margin: 0 auto;
  max-width: 1121px;
  text-align: center;
}

.top-banner section {
  font-family: "GothamBook", sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin: 40px auto 0 auto;
  text-align: center;
  max-width: 1121px;
}

.top-content p.banner-footer {
  font-family: "GothamBook", sans-serif;
  font-size: 24px;
  text-align: center;
}

.bottom-banner {
  color: #FFFFFF;
  display: block;
  font-family: "GothamBook", sans-serif;
  font-size: 20px;
  font-weight: 700;
  margin: 70px auto 0 auto;
  text-align: left;
  width: 1140px;
}

.bottom-banner-text {
  color: #ffffff;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.list-content {
  background: #eeeef3;
  margin: 0 auto;
  position: relative;
  width: 100%;
}

.list-wrap {
  background: #eeeef3;
  display: block;
  margin: 65px auto 102px auto;
  width: 1121px;
}

.list-item {
  background-color: #ffffff;
  border-radius: 0 35px 0 35px;
  box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  height: 400px;
  margin: 0 31px 78px 0;
  position: relative;
  vertical-align: top;
  width: 339px;
}

.list-item a {
  color: #818282;
  display: block;
  font-family: "GothamBook", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  margin: 30px;
  min-height: 54px;
  padding-right: 25%;
}

.list-item p {
  color: #818282;
  font-family: GothamBook, sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin: 0 30px;
  line-height: 17px;
}

.list-item .button {
  background: rgb(26, 64, 132);
  background: linear-gradient(90deg, rgba(26, 64, 132, 1) 0%, rgba(84, 51, 143, 1) 80%, rgba(84, 51, 143, 1) 100%);
  border-radius: 0 0 0 35px;
  border: 0px;
  height: 70px;
  border-top: 4px solid #1c75bc;
  bottom: 0px;
  color: #ffffff;
  font-family: "GothamBook", sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 60px;
  margin: 0;
  padding: 0 70px 0 0;
  position: absolute;
  text-align: right;
  text-decoration: none;
  width: calc(100% - 70px);
}

.list-item .button img {
  position: absolute;
  top: 14px;
  right: 15px;
}

.list-item .button.visit {
  background: rgb(21, 129, 198);
  background: linear-gradient(90deg, rgba(21, 129, 198, 1) 0%, rgba(2, 164, 226, 1) 100%);
  border-top-color: #00467e;
}

.body-list-wrap {
  display: block;
  margin: 65px auto 0 auto;
  width: 1121px;
}

.body-list-item {
  background-color: #ffffff;
  border-radius: 0 35px 0 35px;
  box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 10px -5px 30px 0px rgba(0, 0, 0, 0.15);
  height: 400px;
  margin: 0 32px 78px 0;
  position: relative;
  vertical-align: top;
  width: 338px;
}

.body-list-item div {
  color: #818282;
  display: block;
  font-family: "GothamBook", sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  margin: 30px;
  min-height: 50px;
  padding-right: 29%;
}

.body-list-item p {
  color: #818282;
  font-family: GothamBook, sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin: 0 30px;
  line-height: 17px;
}

.body-list-item button {
  border: 0px;
  bottom: 0px;
  color: #ffffff;
  font-size: 0;
  height: 70px;
  position: absolute;
  width: 349px;
}

.body-list-item button.download {
  background: url(../img/download-button.png) no-repeat bottom left;
}

.body-list-item button.visit {
  background: url(../img/visit-site-button.png) no-repeat bottom left;
}

.pdf-icon {
  background: url(../img/pdf-icon.png) no-repeat top right;
}

.xls-icon {
  background: url(../img/xls-icon.png) no-repeat top right;
}

.ppt-icon {
  background: url(../img/ppt-icon.png) no-repeat top right;
}

.web-icon {
  background: url(../img/web-icon.png) no-repeat top right;
}

.xls-icon {
  background: url(../img/xls-icon.png) no-repeat top right;
}

.doc-icon {
  background: url(../img/doc-icon.png) no-repeat top right;
}

.body-list-item a.no-icon {
  padding-right: 0;
}

.video-thumb {
  cursor: pointer;
  margin-top: 20px;
  text-align: center;
  width: 100%;
}

.steps {
  margin-top: 29px;
}

.step-item {
  border-bottom: 1px solid #6689a5;
  margin-bottom: 21px;
  padding-bottom: 23px;
  width: 100%;
}

.step-item:last-child {
  border: 0;
}

.step-circle {
  background-color: #FFFFFF;
  font-family: Gotham, sans-serif;
  border-radius: 50px;
  color: #0f3765;
  float: left;
  font-size: 18px;
  font-weight: 800;
  height: 35px;
  padding: 35px 30px 30px 30px;
  width: 40px;
  text-align: center;
}

.step-item-desc-wrap {
  color: #ffffff;
  display: inherit;
  float: left;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  margin-left: 18px;
  width: 977px;
}

.step-title {
  font-family: Gotham, sans-serif;
  font-weight: bold;
  margin: 0;
  padding: 0;
}

.step-title.blue {
  color: #00a0df;
}

.step-desc {
  font-family: GothamBook, sans-serif;
  font-weight: 400;
  line-height: 20px;
}

.mapping-list {
  color: #ffffff;
  font-weight: 400;
  margin-bottom: 80px;
  padding-left: 20px;
}

.mapping-list li {
  display: list-item;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  line-height: 24px;
  list-style-type: disc;
}

.body {
  color: #363636;
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  margin: 59px auto 0 auto;
  line-height: 20px;
  width: 1121px;
}

.body .references {
  display: block;
  font-family: "GothamBook", sans-serif;
  font-size: 14px;
  line-height: 21px;
  margin: 0;
  width: 1121px;
}

.subhead {
  font-size: 20px;
  font-weight: bold;
}

.top-link {
  background: url(../img/icon-backToTop.png) no-repeat center right;
  bottom: -40px;
  color: #A65103;
  font-family: GothamMedium, sans-serif;
  font-size: 18px;
  position: absolute;
  right: 115px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  line-height: 42px;
  padding-right: 56px;
}

strong {
  font-weight: bold;
}

@media screen and (max-width: 1230px) {
  footer img {
    left: 78%;
  }

  .step-circle {
    margin: 60px 0 45px 0;
  }

  .top-banner *,
  .body * {
    max-width: 95%;
  }

  .bottom-banner,
  .list-wrap,
  .home-body {
    width: 90%;
  }

  .list-wrap {
    margin-bottom: 0;
    /*text-align: center;*/
  }

  .list-item {
    margin: 0 38px 60px 0;
    text-align: left;
  }

}

@media screen and (max-width: 1024px) {

  .bottom-banner,
  .body,
  .top-banner section {
    width: 90%;
  }

  .step-item-desc-wrap {
    width: 100%;
  }

}

@media screen and (max-width: 880px) {
  .remove-br {
    display: none;
  }

  .top-banner {
    background: url(../img/banner-mobile3-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    margin-left: 1.5%;
    padding-bottom: 46px;
    width: 98.5%;
  }

  .top-banner section {
    font-family: GothamBook, sans-serif;
    font-size: 28px;
    line-height: 30px;
    width: 86%;
  }

  .top-content p.banner-footer {
    font-size: 30px;
    margin: 24px auto;
    width: 73%;
  }

  .resources {
    margin: 80px auto 0 auto;
    width: 80%;
  }

  .resources>div {
    padding-left: 0;
    margin-right: 28px;
    margin-bottom: 70px;
    width: 297px;
  }

  .resources div:nth-child(2n) {
    margin-right: 0;
    width: 260px;
  }

  .resources div:nth-child(2n) .resource_info_wrap {
    border-right: 0;
    margin: 0 0 25px 0;
  }

  .resources .resource_info_wrap {
    margin: 0 37px 25px 0;
    padding-right: 0px;
    width: 100%;
  }

  .home-body {
    width: 87%;
  }

  .top-banner h2 {
    width: 96%;
  }

  .bottom-banner {
    padding-left: 60px;
    padding-right: 60px;
    width: calc(100% - 120px);
  }

  .step-item-desc-wrap {
    width: 95%;
  }

  .step-item {
    text-align: center;
  }

  .step-circle {
    margin: 60px 0 45px 0;
  }

  .step-item-desc-wrap {
    text-align: left;
  }

  .list-wrap {
    width: 85%;
  }

  .list-content {
    padding-bottom: 50px;
  }

  .list-item {
    margin-right: 38px;
    width: 300px;
  }

  .list-item button {
    width: 300px;
    background-size: contain;
  }

  .body {
    width: 90%;
  }

  .body .subhead {
    width: 100%;
  }

  .body-list-wrap,
  .body .references,
  .body-list-item button {
    width: 100%;
  }

  .body-list-item {
    margin-right: 37px;
    width: 300px;
  }

  .list-item:nth-child(2n) {
    margin: 0;
  }

  .list-item:nth-child(3n) {
    margin: 0 32px 78px 0;
  }

  .body-list-item:nth-child(2n) {
    margin: 0;
  }

  .body-list-item:nth-child(3n) {
    margin: 0 32px 78px 0;
  }

  .list-content .subhead,
  .list-content .subhead-description {
    padding-left: 37px;
    padding-right: 37px;
    width: calc(100% - 74px);
  }

  .top-link {
    bottom: 4px;
    right: 35px;
  }

}

@media screen and (max-width: 880px) {

  .top-banner header .logo img {
    width: 60%;
  }

}

@media screen and (max-width: 540px) {

  .top-banner {
    padding-bottom: 26px
  }

  .resources .resource_info_wrap {
    border-right: 0;
    margin: 0 0 25px 0;
  }

  .resources div a {
    display: block;
    height: 55px;
  }

  .resources>div button {
    width: 100%;
  }

  .resources>div,
  .resources div:nth-child(2n) {
    width: 100%;
  }

  .bottom-banner {
    padding-left: 30px;
    padding-right: 30px;
    width: calc(100% - 60px);
  }

  .list-item {
    margin: 0 0 60px 0;
  }

  .top-banner section {
    font-size: 23px;
  }

  .body {
    width: 86%;
  }

  .body-list-item,
  .body-list-item:nth-child(2n),
  .body-list-item:nth-child(3n),
  .list-item:nth-child(2n),
  .list-item:nth-child(3n) {
    margin: 0 0 60px 0;
  }

  .top-banner h1 {
    font-size: 19px;
    line-height: 23px;
    width: 82%;
    margin: 40px auto 20px auto;
  }

  .top-banner h2 {
    font-size: 16px;
    line-height: 18px;
    width: 82%;
  }

  .top-banner h1 span {
    display: block;
    font-size: 14px;
    line-height: 18px;
    margin-top: 20px;
  }

  .top-banner section {
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    margin-top: 25px;
    width: 90%;
  }

  .top-content p.banner-footer {
    font-size: 15px;
    line-height: 18px;
  }

  .list-wrap {
    text-align: center;
  }

}

@media screen and (max-width: 415px) {

  .top-content {
    padding-bottom: 28px;
  }

  .bottom-banner {
    padding-left: 30px;
    padding-right: 30px;
    margin-top: 38px;
    font-size: 16px;
    line-height: 18px;
    width: 84%;
  }

  .bottom-banner p {
    font-size: 14px;
    line-height: 16px;
  }

  .list-wrap {
    padding-left: 0;
    width: 100%;
  }

  .list-item {
    margin: 0 0 60px 0;
  }

  .step-circle {
    margin: 20px 106px 40px 106px;
  }

  .mapping-list li {
    font-size: 14px;
    line-height: 18px
  }

  @supports (-webkit-touch-callout: none) {
    .filter-list span {
      line-height: 32px;
    }

    .filter-content .apply {
      line-height: 70px;
    }

    .top-link {
      padding-top: 12px;
    }

  }
}

/*max-width 280px*/
@media screen and (max-width: 320px) {
  .list-item {
    width: 270px;
  }

  .step-circle {
    float: unset;
    margin: 20px 0px 40px 0px
  }

  .bottom-banner {
    padding: 0px;
  }
}


/*Tag Sup*/
.top-banner sup,
.bottom-banner sup {
  font-size: 11px;
  font-weight: 400;
  margin: 0 0 0 2px;
  vertical-align: text-bottom;
}

@media screen and (max-width: 880px) {
  .top-banner sup {
    vertical-align: 8px;
    line-height: 1;
  }
}

@media screen and (max-width: 540px) {

  .top-banner sup,
  .bottom-banner sup {
    font-size: 8px;
    line-height: unset;
    vertical-align: text-bottom;
  }
}

/*. Tag Sup*/
</style>



// WEBPACK FOOTER //
// src/components/Process_Evaluation.vue